




















































import { Vue, Component } from 'vue-property-decorator'
import Title from '@/components/PageTitle.vue'
import { Action } from 'vuex-class'
import { Step } from '../store'

@Component({
  components: {
    Title
  }
})
export default class Shop extends Vue {
  private options = [
    '統一超商',
    '全家便利商店',
    'OK便利商店',
    '萊爾富便利商店'
  ]

  private shopSelected = 'false'
  private email = ''
  private contractConfirm = false
  private emailHasError = false
  private shopHasError = false

  @Action('stepTo') stepTo!: Function
  mounted () {
    this.stepTo(Step.PaymentInput)
  }
  checkShopSelect () {
    this.shopHasError = this.shopSelected === 'false'
  }

  checkEmail () {
    this.emailHasError = !/.+@.+\..+/.test(this.email)
  }
  onConfirm () {
    if (this.shopHasError || this.emailHasError) {
      return false
    }
    this.$router.push({ path: '/finish-shop', query: { shop: this.shopSelected } })
  }
}
